export default __webpack_public_path__ + "static/4-19220b4b6f5e4b7e39844152051906bf.png";